module.exports = __webpack_public_path__ + "static/PHORENE-1e19d54dd48e40cee32179fe8666eb37.svg";